<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
    show: boolean;
}>();

const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'generate', name: string, scopes: string[]): void;
}>();

const name = ref('');
const selectedScopes = ref<string[]>([]);
const availableScopes = [
    { id: 'sport:schedule:read', label: 'Visualiser le planning des sessions des salles' },
    { id: 'sport:sessions:read', label: "Visualiser les sessions d'une personne (vos sessions)" },
    { id: 'sport:friends_sessions:read', label: 'Visualiser les sessions de vos amis' }
];

const submit = () => {
    emit('generate', name.value, selectedScopes.value);
};

const close = () => {
    name.value = '';
    selectedScopes.value = [];
    emit('close');
};
</script>

<template>
    <div v-if="show" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Générer une Clé API</h5>
                    <button type="button" class="btn-close" @click="close" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label">Nom de la clé</label>
                        <input 
                            v-model="name" 
                            type="text" 
                            class="form-control" 
                            placeholder="Ex: Assistant IA, Home Assistant..." 
                            maxlength="50"
                        />
                    </div>
                    
                    <div class="mb-3">
                        <label class="form-label">Droits (Scopes)</label>
                        <div v-for="scope in availableScopes" :key="scope.id" class="form-check">
                            <input 
                                class="form-check-input" 
                                type="checkbox" 
                                :value="scope.id" 
                                :id="scope.id"
                                v-model="selectedScopes"
                            >
                            <label class="form-check-label" :for="scope.id">
                                {{ scope.label }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close">Annuler</button>
                    <button 
                        type="button" 
                        class="btn btn-primary" 
                        :disabled="!name.trim() || selectedScopes.length === 0"
                        @click="submit"
                    >
                        Générer la clé
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Scoped styles specific to the modal if needed */
</style>
